import api from './api';

export const getUsers = async (params = {}) => {
  const response = await api.get('/users', { params });
  return response.data;
};

export const getUser = async (id) => {
  const response = await api.get(`/users/${id}`);
  return response.data;
};

export const createUser = async (userData) => {
  const response = await api.post('/users', userData);
  return response.data;
};

export const updateUser = async (id, userData) => {
  const response = await api.put(`/users/${id}`, userData);
  return response.data;
};

export const deleteUser = async (id) => {
  const response = await api.delete(`/users/${id}`);
  return response.data;
};

export const updateUserStatus = async (id, isActive) => {
  const response = await api.put(`/users/${id}/status`, { isActive });
  return response.data;
};

export const updateUserRole = async (id, role) => {
  const response = await api.put(`/users/${id}/role`, { role });
  return response.data;
};

export const getUserStats = async () => {
  const response = await api.get('/users/stats');
  return response.data;
};

export const searchUsers = async (params = {}) => {
  const response = await api.get('/users/search', { params });
  return response.data;
};

export const getActiveUsers = async () => {
  const response = await api.get('/users/active');
  return response.data;
};

export const getUserActivities = async (id, params = {}) => {
  const response = await api.get(`/users/${id}/activities`, { params });
  return response.data;
};
